/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ReactionTypeEnum } from '../models/ReactionTypeEnum';
import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class GroupDiscussionCommentReaction {
    'comment': number;
    'user': SimpleUser;
    'reaction': ReactionTypeEnum;
    'dtCreated': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "comment",
            "baseName": "comment",
            "type": "number",
            "format": ""
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "reaction",
            "baseName": "reaction",
            "type": "ReactionTypeEnum",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return GroupDiscussionCommentReaction.attributeTypeMap;
    }

    public constructor() {
    }
}



